import { ErgebnisQuelleAllgemein } from './ergebnis-quelle-allgemein.model';

export class AuswahlAnzeigeAllgemein {
  bezeichnung: string;
  gewichtungsfaktor: number;
  emissionGe: number;
  xKoordinate: number;
  yKoordinate: number;

  constructor(ergebnisQuelleAllgemein: ErgebnisQuelleAllgemein) {
    this.bezeichnung = ergebnisQuelleAllgemein.bezeichnung;
    this.gewichtungsfaktor = ergebnisQuelleAllgemein.gewichtungsfaktor;
    this.emissionGe = ergebnisQuelleAllgemein.emissionGe;
    this.xKoordinate = ergebnisQuelleAllgemein.xKoordinate;
    this.yKoordinate = ergebnisQuelleAllgemein.yKoordinate;
  }
}
